var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddGreen01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "77.041 152.058 18 18",
    enableBackground: "new 77.041 152.058 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#2d8245",
    d: "M94.041,160.058h-7v-7c0-0.553-0.447-1-1-1s-1,0.447-1,1v7h-7 c-0.553,0-1,0.447-1,1s0.447,1,1,1h7v7c0,0.553,0.447,1,1,1s1-0.447,1-1v-7h7c0.552,0,1-0.447,1-1S94.592,160.058,94.041,160.058z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGreen01);
export default __webpack_public_path__ + "static/media/add-green-01.01435d285d21146304c4453fb3b28701.svg";
export { ForwardRef as ReactComponent };